import { render, staticRenderFns } from "./RecordBase.vue?vue&type=template&id=6aa2fd51&scoped=true"
import script from "./RecordBase.vue?vue&type=script&lang=js"
export * from "./RecordBase.vue?vue&type=script&lang=js"
import style0 from "./RecordBase.vue?vue&type=style&index=0&id=6aa2fd51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2fd51",
  null
  
)

export default component.exports